export const DEFAULT_USER_COLOR = '#B799FF';
